import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function ComplianceIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 28 32"
        {...props}
      >
        <path
          stroke="#503291"
          strokeWidth={1.5}
          d="M14.013.75q.035 0 .065.02c.252.176.55.378.757.515a35 35 0 0 0 11.486 5.11l.012.002a.115.115 0 0 1 .09.112v7.375A18.35 18.35 0 0 1 15.69 30.62l-.005.002a26 26 0 0 1-1.5.597.55.55 0 0 1-.276.023l-.09-.023a20 20 0 0 1-.68-.256l-.666-.278A18.36 18.36 0 0 1 1.576 13.884V6.509a.115.115 0 0 1 .09-.112l.01-.002a35 35 0 0 0 11.64-5.192l.01-.007.01-.008c.205-.151.345-.233.61-.418h.001a.1.1 0 0 1 .066-.02Z"
        />
        <path
          stroke="#503291"
          strokeWidth={1.5}
          d="M13.983 9.891a5.74 5.74 0 1 1 0 11.481 5.74 5.74 0 0 1 0-11.48Z"
        />
        <path
          fill="#503291"
          d="m13.805 17.94 3.553-3.369a.608.608 0 0 0-.835-.883l-3.12 2.955-1.418-1.46a.608.608 0 0 0-.872.848l1.84 1.893a.61.61 0 0 0 .855.016z"
        />
      </svg>
    </Icon>
  )
}
export default ComplianceIcon
